import { AccordionButton as ChakraAccordionButton } from '@chakra-ui/react';

type AccordionButtonProps = React.ComponentProps<typeof ChakraAccordionButton>;

const AccordionButton = ({
  children,
  ...props
}: Readonly<AccordionButtonProps>) => {
  return <ChakraAccordionButton {...props}>{children}</ChakraAccordionButton>;
};

export default AccordionButton;
